define("auth/controllers/update_password", ["exports", "@ember/controller", "@ember/service", "@glimmer/tracking", "ember-concurrency-decorators", "later/utils/fetch", "later/utils/constants"], function (_exports, _controller, _service, _tracking, _emberConcurrencyDecorators, _fetch, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let UpdatePasswordController = (_class = class UpdatePasswordController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "alerts", _descriptor, this);

      _initializerDefineProperty(this, "errors", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _initializerDefineProperty(this, "router", _descriptor4, this);

      _defineProperty(this, "queryParams", ['reset_password_token']);

      _defineProperty(this, "reset_password_token", null);

      _initializerDefineProperty(this, "confirmNewPassword", _descriptor5, this);

      _initializerDefineProperty(this, "newPassword", _descriptor6, this);
    }

    get canSave() {
      return this.newPassword === this.confirmNewPassword;
    }

    *resetPassword() {
      const url = '/users/password.json';

      if (!this.canSave) {
        this.alerts.alert(this.intl.t('alerts.reset_password.passwords_must_match'));
        return;
      }

      if (!this.reset_password_token) {
        this.alerts.alert(this.intl.t('alerts.reset_password.no_token'));
        return;
      }

      try {
        const response = yield (0, _fetch.fetch)(url, {
          method: _constants.HttpMethod.Put,
          body: JSON.stringify({
            user: {
              reset_password_token: this.reset_password_token,
              password: this.newPassword,
              password_confirmation: this.confirmNewPassword
            }
          })
        });

        if (response) {
          this.alerts.success(this.intl.t('alerts.reset_password.success'));
          this.router.transitionTo('user.login');
        }
      } catch (error) {
        this.errors.handleAdapter(error);
      }

      this.newPassword = '';
      this.confirmNewPassword = '';
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "confirmNewPassword", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "newPassword", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "resetPassword", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "resetPassword"), _class.prototype)), _class);
  _exports.default = UpdatePasswordController;
});